// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__21pta","cell":"ColumnAccessor_cell__3KBlX","firstCellAccent":"ColumnAccessor_firstCellAccent__310i1"};